import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <Card className="bg-[#1a1a1a] border-gray-800 max-w-md w-full mx-4">
        <CardContent className="pt-6 text-center space-y-4">
          <div className="flex justify-center">
            <div className="w-16 h-16 bg-green-600/20 rounded-full flex items-center justify-center">
              <CheckCircle2 className="w-10 h-10 text-green-500" />
            </div>
          </div>
          
          <h1 className="text-2xl font-bold">Pagamento Realizado!</h1>
          <p className="text-gray-400">
            Seu pagamento está sendo processado. Os tokens serão creditados em sua conta em instantes.
          </p>
          
          <div className="pt-4">
            <Button
              className="bg-red-600 hover:bg-red-700 w-full"
              onClick={() => navigate("/login")}
            >
              Voltar ao Dashboard
            </Button>
          </div>
          
          {sessionId && (
            <p className="text-xs text-gray-500">
              ID da sessão: {sessionId}
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
